import { useContext, useMemo } from 'react';
import { FormControlLabel, Switch, Typography } from '@mui/material';
import FilterContext from '../../contexts/FilterContext';

const BooleanFilterOption = ({ label, onApplyFilter, value, filterKey }) => {
  const { filters, resetFilterByKey } = useContext(FilterContext);

  const handleOnApplyFilter = (event) => {
    if (event.target.checked) {
      onApplyFilter(value);
    } else {
      resetFilterByKey(filterKey);
    }
  };

  const isChecked = useMemo(
    () => filters.some((filter) => filter.key() === filterKey),
    [filters, filterKey]
  );

  return (
    <FormControlLabel
      control={<Switch color="info" checked={isChecked} onChange={handleOnApplyFilter} />}
      label={<Typography>{label}</Typography>}
    />
  );
};

export default BooleanFilterOption;
